module.exports = __webpack_public_path__ + "img/drops-bg1.590b042d.jpg";